export const HOME = {
  emergentLink: "emergent-link",
  heroHeading: "hero-heading",
  heroCtaPrimary: "hero-cta-primary",
  heroCtaSecondary: "hero-cta-secondary",
  wealthCounter: "wealth-counter",
  infraMap: "infra-map",
  roiCalculator: "roi-calculator",
  consultationForm: "consultation-form",
  aiMatchBtn: "ai-match-btn",
  newsletterForm: "newsletter-form",
};

export const NAV = {
  logo: "nav-logo",
  propertiesLink: "nav-properties",
  developersLink: "nav-developers",
  consultationCta: "nav-consultation-cta",
  mobileMenu: "nav-mobile-menu",
  mobileMenuBtn: "nav-mobile-menu-btn",
};

export const PROPERTIES = {
  grid: "properties-grid",
  card: "property-card",
  filterBar: "filter-bar",
  searchInput: "search-input",
};

export const PROPERTY_DETAIL = {
  title: "property-detail-title",
  enquiryForm: "property-enquiry-form",
  enquirySubmit: "enquiry-submit-btn",
  whatsappCta: "whatsapp-cta",
};

export const FORMS = {
  nameInput: "form-name-input",
  phoneInput: "form-phone-input",
  emailInput: "form-email-input",
  budgetSelect: "form-budget-select",
  timelineSelect: "form-timeline-select",
  submitBtn: "form-submit-btn",
  successMsg: "form-success-msg",
};

export const DEVELOPERS = {
  grid: "developers-grid",
  card: "developer-card",
};

export const WHATSAPP = {
  stickyBtn: "whatsapp-sticky-btn",
};
